import React from 'react'
import './cloud.css'

function Cloud() {
  return (
    <div className="cloud">
        <h1>Implante absorvente</h1>
        <h1>Prótese dentária</h1>
        <h1>cirurgia bucomaxilofacial</h1>
        <h1>extração dentária</h1>
        <h1>Periodontia</h1>
        <h1>Ortodontia</h1>
        <h1>endodontia</h1>
        <h1>Odontologia estetica</h1>
        <h1>Clareamento dental</h1>
        <h1>Reabilitação oral</h1>
        <h1>Odontologia preventiva</h1>
        <h1>aparelho de som</h1>
        <h1>tratamento de canal</h1>
        <h1>Implante controlada com carga imediata</h1>
        <h1>Enxerto ósseo</h1>
        <h1>odontologia infantil</h1>
        <h1>bruxismo</h1>
        <h1>Ronco e apnéia do sono</h1>
        <h1>Disfunção da ATM</h1>
        <h1>odontologia digital</h1>
        
    </div>
  )
}

export default Cloud